import { CART_MODULE } from "@/api_framework/api_config";
import { IHDCartAddressUpdatePutBody, IHDCartAddressUpdatePutResponse } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { setAddressUpdate } from "@/app_redux/reducers/slices/auth/cart_slice";

AxiosCurlirize(axios, () => {});

export const useAddressUpdateAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError, toastNotification } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (addressId: string, body: IHDCartAddressUpdatePutBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: any = await axios
          .put(`${CART_MODULE?.ADDRESS_UPDATE?.baseURL}${addressId}/`, body, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IHDCartAddressUpdatePutResponse>) => {
            if (res.data.status === true) {
              toastNotification(res.data.message);
              dispatch(setAddressUpdate({ data: res.data.data }));
              return { status: true, message: null };
            } else {
              dispatch(setAddressUpdate({ data: null }));
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);

            return { status: false, message: null };
          });
        return response;
      } catch (e) {
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
